import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化',
  title1: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化',
  introduction_text:
    'アート引越センター様のDX推進施策の一環として、AIを使った自動見積りアプリの開発を担当しました。AI技術を使用することで、今まで以上に誤差のない正確な見積りができるのではないかという仮説を立て、スマホアプリの開発まで実施しました。',
  company: 'アート引越センター株式会社',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'クラウドネイティブ',
  tag2src: '/cases/cloudnative/',
  tag3text: 'AI',
  tag3src: '/cases/ai/',
  industryTagText: 'サービス',
  industryTagSrc: '/cases/service/',
  color: '#fff',
  background: 'linear-gradient(181deg, #0068B7 -36.36%, #5D41C6 112.21%)',
  staff1: '執行役員 田代憲さん',
  staff2: 'エリア統括ブロック長 小林直人さん',
  staff3: 'プロジェクトメンバー 畠山菜織さん',
  image: '/images/img/cases/gurutto-ai/gurutto-ai.webp',
  alt: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化',
  imgClass: 'fv_img_adjust2',
  noProtrude: true,
  award: '/images/img/cases/gurutto-ai/dx_award.webp',
  awardAlt: 'DX大賞 受賞',
}

// プロジェクト概要
export const overviewTitle = '専用AIモデルを構築し、UX/UIデザインにもこだわったスマホアプリを開発'

export const overviewItem: OverviewItems[] = [
  {
    text: '1976年に日本初の引越専業企業として創業して以来、「引っ越しは運送業ではなくサービス業」という信念のもと、業界初となる数多くの商品やサービスを開発してきたアート引越センター。',
  },
  {
    text: '暮らし方を提案する企業、そして業界のリーディングカンパニーでもあるアート引越センターにとって、物流業界における2024年問題をはじめとした働き方改革、労働力不足や少子高齢化といった社会的な課題への対応は急務でした。こうした背景からスタートしたのが、アート引越センターのDX推進施策。その一環としてこのプロジェクトがスタート。AIを使った自動見積りアプリの開発をAitriaが担当しました。',
  },
  {
    text: '今回は、プロジェクトの牽引役であった執行役員の田代憲さんのほか、エリア統括ブロック長の小林直人さん、プロジェクトメンバーの畠山菜織さんにお話を伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '見積りの定量化',
        text: '人の目によって顧客の多種多様な家財の内容から総物量を判断するため、どうしても誤差が生じる。',
      },
      {
        title: '複雑な業務で要件化が困難',
        text: '引っ越しの手配業務は複雑で多岐にわたるため、経験値が必要。必要な要件の言語化が課題。',
      },
      {
        title: 'デジタルとアナログの見積りの両立',
        text: 'ライフスタイルが多様化する中で、従来通りのスタッフによる優れた見積りと、精度の高い見積りをデジタルで完結させることの両立が求められる。',
      },
    ],
    solutions: [
      {
        title: '家具の物量を積算するAIを一から開発',
        text: '大量の部屋データを集め、点群をAIに学習させることで、家具や家財の認識ができるAIを開発。',
      },
      {
        title: '実体験を通した深い業界理解',
        text: '実際に現場に赴き体験することで、言語化しにくいユーザーやクライアントの細かなニーズまで汲み取り、プロダクトに反映。',
      },
      {
        title: '無人対応可能な高精度のシステム',
        text: '主に単身引越の物量までは、人の目と誤差がない精度の高い見積りが可能なシステムを提供。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '属人化した業務、AIで標準化しませんか？',
  description:
    '現場に足を運び業界特有の業務を深く理解した上で、AIモデルの開発からアプリのUX/UI設計まで一気通貫でご支援します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
